import ryEmoji from "ryEmoji"; //融云表情

import Store from "@/store";
import Logger from "@/utils/logger";
import utils from "@/utils/util";

import {
  MessageTypes,
  PushTypes,
  RongYunConnectStatus
} from "@/constant/rongyun";

import { getChineseKey, getLanguage } from "@/lang/index";

import isEmpty from "lodash/isEmpty";
import DateUtil from "@/utils/format_date.js";
import isString from "lodash/isString";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";

const RongIMLib = window.RongIMLib;
let token = null;
// const RCS = window.RCS;

export const emoji = {
  init: function() {
    ryEmoji.init();
    return ryEmoji.list;
  },
  emojiToHTML: function(emojiContent) {
    // console.log("emojiContent",emojiContent);
    return ryEmoji.emojiToHTML(emojiContent);
  },
  symbolToEmoji: function(sym) {
    return ryEmoji.symbolToEmoji(sym);
  },
  getEmoji: function() {
    return ryEmoji.list.map(function(data) {
      return data.node;
    });
  },
  emojiToSymbol: function(text) {
    return ryEmoji.emojiToSymbol(text);
  }
};
// 自定义表情配置
export function getGifConfig() {
  let gifConfig = {
    staticSrc: "/static/images/chat/",
    groups: [
      {
        groupName: "emoji1",
        // groupImg: require('@/assets/images/chat/gif-gulid1.png'),
        len: 31,
        prefix: "lottery",
        list: []
      },
      {
        groupName: "emoji2",
        // groupImg: require('@/assets/images/chat/gif-gulid2.png'),
        len: 16,
        prefix: "chick",
        list: []
      }
    ]
  };
  for (let groups of gifConfig.groups) {
    for (let j = 1; j < groups.len; j++) {
      groups.list.push({
        src: groups.prefix + "_" + j + ".gif"
      });
    }
  }
  return gifConfig;
}

// 待移除 不该存在此文件内
export const BarOption = {
  barColor: "#959595", //滚动条颜色
  barWidth: 6, //滚动条宽度
  railColor: "#eee", //导轨颜色
  barMarginRight: 0, //垂直滚动条距离整个容器右侧距离单位（px）
  barMaginBottom: 0, //水平滚动条距离底部距离单位（px)
  barOpacityMin: 0.3, //滚动条非激活状态下的透明度
  zIndex: "auto", //滚动条z-Index
  autohidemode: true, //自动隐藏模式
  horizrailenabled: false //是否显示水平滚动条
};

/**
 * 调用connectRongYun前必须调用此方法初始化融云
 * @param appKey
 */
export function initRongYun(appkey) {
  RongIMLib.init({ appkey });
}

/**
 * 获取融云实例
 * @return {*}
 */
export async function getRongYunInstance() {
  await RongIMLib.getInstance();
  return RongIMLib.getInstance();
}

/**
 * 设置监听
 */
export function setWatch(options = {}) {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }
  const { onReceived, onChanged } = options;
  const Events = RongIMLib.Events;

  /**
   * 正在链接的事件状态
   */
  RongIMLib.addEventListener(Events.CONNECTING, () => {
    Logger.prefixed.log("融云", "正在连接中");
    onChanged && onChanged(RongYunConnectStatus.CONNECTING);
  });

  /**
   * 链接到服务器会触发这个事件
   */
  RongIMLib.addEventListener(Events.CONNECTED, () => {
    Logger.prefixed.log("融云", "链接成功");
    onChanged && onChanged(RongYunConnectStatus.CONNECTED);
  });

  /**
   * 手动调用 disconnect 方法或者用户被踢下线 会触发这个事件
   */
  RongIMLib.addEventListener(Events.DISCONNECT, () => {
    Logger.prefixed.log("融云", "连接中断");
    onChanged && onChanged(RongYunConnectStatus.DISCONNECTED);
  });

  /**
   * 链接出问题时，内部进行重新链接，会出发这个事件
   */
  RongIMLib.addEventListener(Events.SUSPEND, () => {
    Logger.prefixed.log("融云", "链接异常断开(自动重连)");
    onChanged && onChanged(RongYunConnectStatus.SUSPEND);
  });

  RongIMLib.addEventListener(Events.MESSAGES, res => {
    const messages = res.messages || [];
    messages.forEach(message => {
      onReceived && onReceived(message);
    });
  });
  // const conversationList = []; // 当前已存在的会话列表
  // setWatch.watcher && RongIMLib.unwatch(setWatch.watcher);
  // setWatch.watcher = {
  //   conversation: async function(event) {
  //     var updatedConversationList = await event.updatedConversationList; // 更新的会话列表
  //     const merge = await RongIMLib.Conversation.merge({
  //       conversationList,
  //       updatedConversationList
  //     });
  //   },
  //   message: async function(event) {
  // 	await event;
  //     const message = await event.message;
  //     onReceived && onReceived(message);
  //   },
  // };
  // RongIMLib.watch(setWatch.watcher);
}

/**
 * 连接到融云
 * @param token
 * @param options {onSuccess, onTokenIncorrect, onError}
 */
export function connectRongYun(newToken, options = {}) {
  const { onSuccess, onError } = options;
  token = newToken;
  RongIMLib.connect(token).then(res => {
    const code = res.code;
    // Logger.prefixed.log("开始连接融云", { token });
    if (code === 0) {
      onSuccess && onSuccess(res.data.userId);
    } else {
      Logger.prefixed.error(`融云','连接错误 code: ${code}`);
      onError && onError(new Error(`${code}`));
    }
  });
}
/**
 * 断开链接
 */
export async function disconnect() {
  return await logout();
}
/**
 * 退出融云登录
 */
export async function logout() {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }
  Logger.prefixed.debug("融云", "logout");
  RongIMLib.getConnectionStatus = function() {};
  try {
    RongIMLib.getConnectionStatus();
  } catch (e) {
    return e;
  }
  return RongIMLib.disconnect().then(() => {
    Logger.prefixed.debug("融云", "连接已断开");
  });
}
/**
 * 重新连接到融云
 * @param options
 */
export function reconnect(options = {}) {
  const { onSuccess, onError } = options;
  RongIMLib.connect(token).then(res => {
    const code = res.code;
    if (code === 0) {
      Logger.prefixed.log("融云", "Reconnect successfully. " + res.data.userId);
      onSuccess && onSuccess(res.data.userId);
    } else {
      Logger.prefixed.error("融云", "重新链接失败", new Error(`${code}`));
      onError && onError(new Error(`${code}`));
    }
  });
}
/**
 * 加入聊天室
 * @param chatRoomId 聊天室 id
 * @param count 拉取聊天数, 范围 0 - 50
 * @param options {onSuccess, onError}
 */
export async function joinChatRoom(chatRoomId, count, options = {}) {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }
  const { onSuccess, onError } = await options;
  RongIMLib.joinChatRoom(chatRoomId, {
    count
  })
    .then(res => {
      if (res.code === 0) {
        Logger.prefixed.log("融云", `加入聊天室成功，请求历史消息数量${count}`);
        onSuccess && onSuccess();
      } else {
        const e = new Error(`code: ${res.code}, msg: ${res.msg}`);
        onError && onError(e);
      }
    })
    .catch(error => {
      onError && onError(error);
    });
}
/**
 * 退出聊天室
 * @param chatRoomId 聊天室 id
 * @param options {onSuccess, onError}
 */
export async function quitChatRoom(chatRoomId, options = {}) {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }

  const { onSuccess, onError } = await options;
  RongIMLib.quitChatRoom(chatRoomId)
    .then(res => {
      if (res.code === 0) {
        Logger.prefixed.debug("融云", "退出聊天室成功");
        onSuccess && onSuccess();
      } else {
        const e = new Error(`code: ${res.code}, msg: ${res.msg}`);
        Logger.prefixed.error("融云", "退出聊天室失败", e);
        onError && onError(e);
      }
    })
    .catch(e => {
      Logger.prefixed.error("融云", "退出聊天室失败", e);
      onError && onError(e);
    });
}
/**
 * 发送消息:
 * 聊天室发言 or 私讯
 * @param conversationType
 * @param targetId
 * @param message
 * @return {*}
 */
export async function sendMessage(
  conversationType,
  targetId,
  message,
  options = {}
) {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }

  const { onSuccess, onError } = await options;
  await conversationType;
  switch (conversationType) {
    case RongIMLib.ConversationType.PRIVATE:
      sendPrivateMessage(targetId, message)
        .then(res => {
          Logger.prefixed.debug("融云", "私聊消息发送成功", res);
          onSuccess && onSuccess(res.data);
        })
        .catch(e => {
          Logger.prefixed.debug("融云", "私聊消息发送失败", e);
          onError && onError(e);
        });
      break;
    case RongIMLib.ConversationType.CHATROOM:
      sendChatRoomMessage(targetId, message)
        .then(res => {
          Logger.prefixed.debug("融云", "聊天室消息发送成功", message);
          onSuccess && onSuccess(res.data);
        })
        .catch(e => {
          Logger.prefixed.debug("融云", "聊天室消息发送失败", e);
          onError && onError(e);
        });
      break;
  }
}

/**
 * 发送私聊消息
 * @param targetId
 * @param message
 * @return {*}
 */
export async function sendPrivateMessage(targetId, message) {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }
  const conversation = {
    conversationType: RongIMLib.ConversationType.PRIVATE,
    targetId
  };
  return RongIMLib.sendMessage(conversation, message);
}

/**
 * 发送聊天室消息
 * @param targetId
 * @param message
 * @return {*}
 */
export async function sendChatRoomMessage(targetId, message) {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }

  const conversation = {
    conversationType: RongIMLib.ConversationType.CHATROOM,
    targetId
  };
  return RongIMLib.sendMessage(conversation, message);
}

/**
 * 获取会话列表
 * @return {*|Array}
 */
export function getConversationList() {
  return RongIMLib.getConversationList({
    count: 1000
  }).then(res => {
    let conversationList = res.data || [];
    if (res.code === 0) {
      if (conversationList.length) {
        conversationList = conversationList.map(conversation => {
          conversation.latestMessage = MessageManager.normalize(
            conversation.latestMessage
          );
          return conversation;
        });
      }
      return conversationList;
    } else {
      Logger.prefixed.error(
        "融云",
        "获取会话列表失败",
        new Error(`code: ${res.code} msg: ${res.msg}`)
      );
    }
  });
}

export async function deleteRemoteMessages(targetId, messages, options = {}) {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }

  // return RongIMLib.Conversation.get({
  //   targetId,
  //   type: RongIMLib.ConversationType.PRIVATE
  // }).deleteMessages(messages);
  //
  // const defaultOpts = Object.assign(
  //     {
  //       conversationType: RongIMLib.ConversationType.PRIVATE
  //     },
  //     options
  // );
  const defaultOpts = Object.assign(
    {
      conversationType: RongIMLib.ConversationType.PRIVATE
    },
    options
  );
  return RongIMLib.deleteMessages(messages, {
    conversationType: defaultOpts.conversationType,
    targetId: targetId
  })
    .then(res => {
      if (res.code === 0) {
        Logger.prefixed.debug("融云", "删除指定会话成功");
      } else {
        Logger.prefixed.error(
          "融云",
          "删除指定会话成功失败",
          new Error(`code: ${res.code} msg: ${res.msg}`)
        );
      }
    })
    .catch(error => {
      Logger.prefixed.error("融云", "删除指定会话成功失败", error);
    });
}

/**
 *  获取历史消息
 */
export async function getHistoryMessages(
  conversationType,
  targetId,
  options = {}
) {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }

  const defaultOpts = Object.assign(
    {
      timestrap: 0, // 默认传 null，若从头开始获取历史消息，请赋值为 0, timestrap = 0;
      count: 20, // 每次获取的历史消息条数，范围 0-20 条，可以多次获取
      order: 0
    },
    options
  );

  await conversationType;
  switch (conversationType) {
    case RongIMLib.ConversationType.PRIVATE:
      return getPrivateHistoryMessages(targetId, defaultOpts);
    case RongIMLib.ConversationType.CHATROOM:
      return getChatRoomHistoryMessage(targetId, defaultOpts);
  }
}

/**
 * 获取私聊历史消息
 */
export async function getPrivateHistoryMessages(targetId, options = {}) {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }
  // const conversation = await RongIMLib.Conversation.get({
  //   targetId: targetId,
  //   type: RongIMLib.ConversationType.PRIVATE
  // });
  //
  // return conversation.getMessages(options).then(function(result){
  //   if (result.list && result.list.length) {
  //     result.list = result.list.map(message => {
  //       return MessageManager.normalize(message);
  //     });
  //   }
  //   return result;
  // });
  return RongIMLib.getHistoryMessages(
    {
      targetId: targetId,
      conversationType: RongIMLib.ConversationType.PRIVATE
    },
    options
  )
    .then(res => {
      if (res.code === 0) {
        const list = res.data.list || [];
        res.data.list = list.map(message => {
          return MessageManager.normalize(message);
        });
        return res.data;
      }
      Logger.prefixed.error(
        "融云",
        "获取私聊历史消息失败",
        new Error(`code: ${res.code} msg: ${res.msg}`)
      );
      return {
        list: [],
        hasMore: false
      };
    })
    .catch(error => {
      Logger.prefixed.error("融云", "获取私聊历史消息失败", error);
    });
}

/**
 * 获取聊天室历史消息
 */
export async function getChatRoomHistoryMessage(targetId, options = {}) {
  return RongIMLib.getChatroomHistoryMessages(targetId, options)
    .then(res => {
      if (res.code === 0) {
        const list = res.data.list || [];
        res.data.list = list.map(message => {
          return MessageManager.normalize(message);
        });
        return res.data;
      }
      Logger.prefixed.error(
        "融云",
        "获取聊天室历史消息失败",
        new Error(`code: ${res.code} msg: ${res.msg}`)
      );
      return {
        list: [],
        hasMore: false
      };
    })
    .catch(error => {
      Logger.prefixed.error("融云", "获取聊天室历史消息失败", error);
    });
}

/**
 * 删除会话
 * @param targetId
 * @param options
 */
export async function removeConversation(targetId, options = {}) {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }

  const defaultOpts = Object.assign(
    {
      conversationType: RongIMLib.ConversationType.PRIVATE
    },
    options
  );
  return RongIMLib.removeConversation({
    conversationType: defaultOpts.conversationType,
    targetId: targetId
  })
    .then(res => {
      if (res.code === 0) {
        Logger.prefixed.debug("融云", "删除指定会话成功");
      } else {
        Logger.prefixed.error(
          "融云",
          "删除指定会话成功失败",
          new Error(`code: ${res.code} msg: ${res.msg}`)
        );
      }
    })
    .catch(error => {
      Logger.prefixed.error("融云", "删除指定会话成功失败", error);
    });
}

/**
 * 清除会话未读数
 * @param targetId
 * @param option
 * @return {Promise<any>}
 */
export async function clearUnreadCount(targetId, options = {}) {
  // const instance = await getRongYunInstance();
  // if (!instance) {
  //   return;
  // }

  const defaultOpts = await Object.assign(
    {
      conversationType: RongIMLib.ConversationType.PRIVATE
    },
    options
  );

  return RongIMLib.clearMessagesUnreadStatus({
    conversationType: defaultOpts.conversationType,
    targetId
  })
    .then(res => {
      if (res.code === 0) {
        Logger.prefixed.debug("融云", "清除指定会话未读数成功");
      } else {
        Logger.prefixed.error(
          "融云",
          "清除指定会话未读数成功",
          new Error(`code: ${res.code} msg: ${res.msg}`)
        );
      }
    })
    .catch(error => {
      Logger.prefixed.error("融云", "清除指定会话未读数成功", error);
    });
}
/**
 * 扩展功能
 */
export const FeatureEx = {
  hideUserCode: function(userCode) {
    if (!userCode) return;
    return (
      userCode.substr(0, 2) +
      "***" +
      userCode.substr(userCode.length - 2, userCode.length)
    );
  }
};

/**
 * @description 上传图片
 *
 * @param event
 * @param options
 *
 * @example
 * $uploadImage(event, {
 *     onfileBefore: (file, position, message) => {},
 *     onProgress: (loaded, total, file, position, message) => {},
 *     onSuccess: (data, file, position, message) => {},
 *     onError: (e, file, position, message) => {}
 * });
 */
// export async function uploadImage(event, options) {
//   const target = await event.target || event.srcElement;
//   const { onfileBefore, onSuccess, onProgress, onError } = await options || {};
//   const files = target.files || [];
//
//   for (let i = 0; i < files.length; i++) {
//     const file = files[i];
//     (function(file, position) {
//       let imgMessage = MessageManager.factory(MessageManager.CreateModes.kImg);
//       imgMessage.setImageUri(
//         window[window.webkitURL ? "webkitURL" : "URL"]["createObjectURL"](file)
//       );
//       imgMessage = imgMessage.generate();
//       imgMessage.state = 0;
//       imgMessage.progress = "0%";
//       imgMessage.sentTime = new Date().getTime();
//       imgMessage.imageId = `img${imgMessage.sentTime}`;
//       MessageManager.getInstance().addMessageExData(imgMessage);
//       onfileBefore && onfileBefore(file, position, imgMessage);
//
//       RCS.imageStartUpload(
//         file,
//         function(data) {
//           RongIMLib.then(instance => {
//             instance.getFileUrl(
//                 RongIMLib.FILE_TYPE.IMAGE,
//                 data.filename,
//                 data.name,
//                 data
//             )
//                 .then(result => {
//                   data.downloadUrl = result.downloadUrl;
//                   imgMessage.content.content = data.thumbnail;
//                   imgMessage.content.imageUri = data.downloadUrl;
//                   onSuccess && onSuccess(data, file, position, imgMessage);
//                 })
//                 .catch(e => {
//                   imgMessage.state = -1;
//                   onError && onError(e, file, position, imgMessage);
//                 });
//           })
//
//         },
//         {
//           onProgress: function(loaded, total) {
//             const progress = Math.floor((loaded / total) * 100);
//             imgMessage.progress = progress >= 100 ? false : progress + "%";
//             onProgress && onProgress(loaded, total, file, position, imgMessage);
//           },
//           onError: function(e) {
//             imgMessage.state = -1;
//             onError && onError(e, file, position, imgMessage);
//           }
//         }
//       );
//     })(file, i);
//   }
//   target.value = "";
// }

// export async function getFileUrl(data, options) {
//   const { onSuccess } = await options || {};
//   const messageSelFile = function(file) {
//     const name = file.name || "",
//       index = name.lastIndexOf(".") + 1,
//       type = name.substring(index);
//     const fileMessage = MessageManager.factory(
//       MessageManager.CreateModes.kFile
//     );
//     fileMessage.setName(file.name);
//     fileMessage.setSize(file.size);
//     fileMessage.setType(type);
//     fileMessage.setFileUrl(file.downloadUrl);
//     return fileMessage.generate();
//   };
//   const messageSelImg = function(image, extra = {}) {
//     let imgMessage = null
//     if (utils.isGifType(image.filename)) {
//       imgMessage = MessageManager.factory(MessageManager.CreateModes.kGif);
//       imgMessage.setGifDataSize(image.size);
//       imgMessage.setRemoteUrl(image.downloadUrl);
//       imgMessage.setWidth(image.w);
//       imgMessage.setHeight(image.h);
//     } else {
//       imgMessage = MessageManager.factory(MessageManager.CreateModes.kImg);
//       imgMessage.setContent(image.thumbnail);
//       imgMessage.setImageUri(image.downloadUrl);
//     }
//     imgMessage.setExtra(extra);
//     return imgMessage.generate();
//   };
//
//   const messageSelText = function(msg, extra = {}) {
//     msg = emoji.symbolToEmoji(msg);
//     const textMessage = MessageManager.factory(
//       MessageManager.CreateModes.kText
//     );
//     textMessage.setContent(msg);
//     textMessage.setExtra(extra);
//     return textMessage.generate();
//   };
//   const messageSel = {
//     file: messageSelFile,
//     image: messageSelImg,
//     text: messageSelText,
//   };
//
//   const { fileType } = await data;
//
//   const urlSelFile = function(data) {
//     const type = parseInt(data.rc_url.type);
//     const fileConfig = RCS.config.fileConfig;
//     const fileServer = fileConfig.fileServer;
//     const path = data.rc_url.path;
//
//     if (fileConfig && RCS.fileConfig.isPrivate) {
//       if (type === 1) {
//         data.downloadUrl = data.rc_url.path;
//       } else {
//         data.downloadUrl = fileServer + path;
//       }
//       const msg = messageSel[data.fileType](data);
//       onSuccess && onSuccess(msg);
//     } else {
//       const fileType = RongIMLib.FILE_TYPE.FILE;
//       const ryInstance = getRongYunInstance();
//       const success = function(result) {
//         data.downloadUrl = result.downloadUrl;
//         var msg = messageSel[data.fileType](data);
//         onSuccess && onSuccess(msg);
//       };
//       const error = function(error) {
//         Logger.prefixed.error("融云", `urlSelFile error:${error}`);
//       };
//       RongIMLib
//         .getFileUrl(fileType, data.filename, data.name, data)
//         .then(data => {
//           success(data);
//         })
//         .catch(e => {
//           error(e);
//         });
//     }
//   };
//   const urlSelImg = function(data) {
//     if (RCS.config && RCS.config.upload && RCS.config.upload.isPrivate) {
//       const type = parseInt(data.rc_url.type);
//       const path = data.rc_url.path;
//       const fileServer = RCS.config.upload.fileServer;
//       if (type === 1) {
//         data.downloadUrl = path;
//       } else {
//         data.downloadUrl = `${fileServer}${path}`;
//       }
//       const msg = messageSel[data.fileType](data);
//       onSuccess && onSuccess(msg);
//     } else {
//       const fileType = RongIMLib.FILE_TYPE.IMAGE;
//       const ryInstance = getRongYunInstance();
//       const success = function(result) {
//         data.downloadUrl = result.downloadUrl;
//         const msg = messageSel[data.fileType](data);
//         onSuccess && onSuccess(msg);
//       };
//       const error = function(e) {
//         Logger.prefixed.error("融云", `urlSelImg error:${error}`);
//       };
//       RongIMLib
//         .getFileUrl(fileType, data.filename, data.name, data)
//         .then(data => {
//           success(data);
//         })
//         .catch(e => {
//           error(e);
//         });
//     }
//   };
//   const urlSel = {
//     file: urlSelFile,
//     image: urlSelImg
//   };
//   urlSel[fileType](data);
// }

/**
 * // const testMessage = MessageManager.factory("TextMessage");
 * // testMessage.setContent("123456");
 * // testMessage.setExtra();
 * // textMessage.generate();
 */
export const MessageManager = (function() {
  const MessageManager = function() {};
  MessageManager.prototype = {
    constructor: MessageManager,
    printName: function() {
      throw new Error("printName未被实现");
    },
    getContentByMessage(message) {
      if (isEmpty(message)) {
        return {};
      }
      return message.content || {};
    },
    getRemoteDataByMessage(message) {
      if (isEmpty(message)) {
        return {};
      }
      const extra = this.getExtraByMessage(message);
      return extra.data || {};
    },
    getUserByMessage(message) {
      if (isEmpty(message)) {
        return {};
      }
      const messageContent = this.getContentByMessage(message);
      return messageContent.user || {};
    },
    getExtraByMessage(message) {
      if (isEmpty(message)) {
        return {};
      }
      const messageContent = this.getContentByMessage(message);
      return messageContent.extra || {};
    },
    getSenderUserByMessage(message) {
      if (isEmpty(message)) {
        return {};
      }
      const extra = this.getExtraByMessage(message);
      return extra.senderUser || {};
    },
    getReceiveUserByMessage(message) {
      if (isEmpty(message)) {
        return {};
      }
      const extra = this.getExtraByMessage(message);
      return extra.receiveUser || {};
    },
    getUserNameByStore() {
      const userCode = this.getUserCodeByStore();
      if (userCode) {
        return (
          Store.state.user.user.nickName ||
          FeatureEx.hideUserCode(Store.state.chat.chatUser.name)
        );
      }
      return FeatureEx.hideUserCode(Store.state.chat.chatUser.name);
    },
    getUserByStore: function() {
      const name = this.getUserNameByStore();
      const id = this.getUserIdByStore();
      const portrait = this.getUserPortrait();
      return {
        id,
        name,
        portrait
      };
    },
    getSenderUserByStore: function() {
      const name = this.getUserNameByStore();
      const userCode = this.getUserCodeByStore();
      const userLevelIcon = this.getUserLevelIconByStore();
      const nickName = this.getUserNickNameByStore();
      const id = this.getUserIdByStore();
      const portrait = this.getUserPortrait();
      return {
        id,
        name,
        nickName,
        portrait,
        userCode,
        userLevelIcon
      };
    },
    setSenderUser(message, senderUser) {
      if (isEmpty(message)) {
        throw new Error("setSenderUser方法传入的message参数不能为空");
      }
      message.content.extra.senderUser = senderUser;
    },
    addSenderUser(message) {
      if (isEmpty(message)) {
        throw new Error("addSenderUser方法传入的message参数不能为空");
      }
      const senderUser = this.getSenderUserByStore();
      message.content.extra.senderUser = senderUser;
    },
    getKUserMarkTypeByStore: function() {
      if (!Store.state.user.user.userId) {
        return "kUserMarkType_UnLogin"; // 未登录
      } else if (Store.state.user.user.userType === "09") {
        return "kUserMarkType_Guest"; // 试玩
      }
      return "kUserMarkType_Login"; // 登录
    },
    getUserLevelIconByStore: function() {
      return Store.state.user.user.userLevelIcon;
    },
    getUserCodeByStore: function() {
      return FeatureEx.hideUserCode(Store.state.user.user.userCode);
    },
    getUserNickNameByStore: function() {
      return Store.state.user.user.nickName;
    },
    getUserIdByStore: function() {
      return Store.state.chat.chatUser.uid;
    },
    getUserPortrait: function() {
      return Store.state.chat.chatUser.portrait;
    },
    setUser(message, user) {
      if (isEmpty(message)) {
        throw new Error("setUser方法传入的message参数不能为空");
      }
      message.content.user = user;
      return message;
    },
    addUser(message) {
      if (isEmpty(message)) {
        throw new Error("addUser方法传入的message参数不能为空");
      }
      const user = this.getUserByStore();
      message.content.user = user;
      return message;
    },
    getReceiveUser: function(
      id,
      name,
      nickName,
      portrait,
      userCode,
      userLevelIcon
    ) {
      return {
        id,
        name,
        nickName,
        portrait,
        userCode,
        userLevelIcon
      };
    },
    setReceiveUser: function(message, receiveUser) {
      if (isEmpty(message)) {
        throw new Error("addReceiveUser方法传入的message参数不能为空");
      }
      message.content.extra.receiveUser = receiveUser;
      return message;
    },
    addMessageExData: function(message) {
      if (isEmpty(message)) {
        throw new Error("addMessageExData方法传入的message参数不能为空");
      }
      if (isEmpty(message.content.extra)) {
        message.content.extra = {};
      }
      const user = this.getUserByStore();
      const senderUser = this.getSenderUserByStore();
      const kUserMarkType = this.getKUserMarkTypeByStore();
      const userCode = this.getUserCodeByStore();
      const sendUserLevelIcon = this.getUserLevelIconByStore();
      message.content.user = user;
      message.content.extra.senderUser = senderUser;
      message.content.extra.kUserMarkType = kUserMarkType;
      message.content.extra.userCode = userCode;
      message.content.extra.sendUserLevelIcon = sendUserLevelIcon;
      return message;
    }
  };

  // const CreateModes = {
  //   kFile: "FileMessage",
  //   kImg: "ImgMessage",
  //   kText: "TextMessage",
  //   kWelcome: "WelcomeMessage",
  //   kEmoji: "EmojiMessage",
  //   kGif: "GIFMessage",
  //   kRedPacket: "RedPacketMessage",
  //   kRedPacketBattle: "RedPacketBattleMessage"
  // };
  //
  // (function() {
  //   MessageManager.RedPacketBattleMessage = function() {
  //     this.content = "";
  //     this.extra = {};
  //   };
  //
  //   MessageManager.RedPacketBattleMessage.prototype = {
  //     constructor: MessageManager.RedPacketBattleMessage,
  //     generate: function() {
  //       return {
  //         messageType: MessageTypes.RED_PACKET_BATTLE,
  //         content: {
  //           content: this.content,
  //           extra: this.extra
  //         }
  //       };
  //     },
  //     setContent(content) {
  //       this.content = content;
  //     },
  //     getContent() {
  //       return this.content;
  //     },
  //     setExtra(extra) {
  //       Object.assign(this.extra, extra);
  //     },
  //     getExtra() {
  //       return this.extra;
  //     }
  //   };
  // })();
  //
  // (function() {
  //   MessageManager.RedPacketMessage = function() {
  //     this.content = "";
  //     this.extra = {};
  //   };
  //
  //   MessageManager.RedPacketMessage.prototype = {
  //     constructor: MessageManager.RedPacketMessage,
  //     generate: function() {
  //       return {
  //         messageType: MessageTypes.HB,
  //         content: {
  //           content: this.content,
  //           extra: this.extra
  //         }
  //       };
  //     },
  //     setContent(content) {
  //       this.content = content;
  //     },
  //     getContent() {
  //       return this.content;
  //     },
  //     setExtra(extra) {
  //       Object.assign(this.extra, extra);
  //     },
  //     getExtra() {
  //       return this.extra;
  //     }
  //   };
  // })();
  //
  // (function() {
  //   MessageManager.WelcomeMessage = function() {
  //     this.content = "";
  //     this.extra = {};
  //   };
  //
  //   MessageManager.WelcomeMessage.prototype = {
  //     constructor: MessageManager.WelcomeMessage,
  //     generate: function() {
  //       return {
  //         messageType: MessageTypes.WELCOME,
  //         content: {
  //           content: this.content,
  //           extra: this.extra,
  //           user: {
  //             name: "系统消息",
  //             id: "",
  //             portrait: "/static/images/chat/sys_mas.png"
  //           }
  //         }
  //       };
  //     },
  //     setContent(content) {
  //       this.content = content;
  //     },
  //     getContent() {
  //       return this.content;
  //     },
  //     setExtra(extra) {
  //       Object.assign(this.extra, extra);
  //     },
  //     getExtra() {
  //       return this.extra;
  //     }
  //   };
  // })();
  //
  // (function () {
  //   MessageManager.GifMessage = function () {
  //     this.gifDataSize = 0;
  //     this.width = 0;
  //     this.height = 0;
  //     this.remoteUrl = '';
  //     this.extra = {};
  //   };
  //   MessageManager.GifMessage.prototype = {
  //     constructor: MessageManager.GifMessage,
  //     generate: function () {
  //       return {
  //         messageType: RongIMLib.MessageType.GIF,
  //         content: {
  //           gifDataSize:this.gifDataSize,
  //           height:this.height,
  //           remoteUrl: this.remoteUrl,
  //           width:this.width,
  //           extra: this.extra
  //         }
  //       };
  //     },
  //     setGifDataSize(gifDataSize) { this.gifDataSize = gifDataSize; },
  //     getGifDataSize() { return this.gifDataSize; },
  //     setWidth(width) { this.width = width; },
  //     getWidth() { return this.width; },
  //     setHeight(height) { this.height = height; },
  //     getHeight() { return this.height; },
  //     setRemoteUrl(remoteUrl) { this.remoteUrl = remoteUrl; },
  //     getRemoteUrl() { return this.remoteUrl; },
  //     setExtra(extra) { this.extra = extra; },
  //     getExtra() { return this.extra; },
  //   };
  // })();
  // (function() {
  //   MessageManager.EmojiMessage = function() {
  //     this.content = "";
  //     this.extra = {
  //       type: "106"
  //     };
  //   };
  //
  //   MessageManager.EmojiMessage.prototype = {
  //     constructor: MessageManager.EmojiMessage,
  //     generate: function() {
  //       return {
  //         messageType: MessageTypes.Emoji,
  //         content: {
  //           objectName: MessageTypes.Emoji,
  //           content: this.content, // // 压缩后的 base64 略缩图, 用来快速展示图片
  //           extra: this.extra
  //         }
  //       };
  //     },
  //     setContent(content) {
  //       this.content = content;
  //     },
  //     getContent() {
  //       return this.content;
  //     },
  //     setExtra(extra) {
  //       Object.assign(this.extra, extra);
  //     },
  //     getExtra() {
  //       return this.extra;
  //     }
  //   };
  // })();
  //
  // (function() {
  //   MessageManager.FileMessage = function() {
  //     this.name = "";
  //     this.size = 0;
  //     this.type = "";
  //     this.fileUrl = "";
  //   };
  //
  //   MessageManager.FileMessage.prototype = {
  //     constructor: MessageManager.FileMessage,
  //     generate: function() {
  //       return {
  //         messageType: RongIMLib.MessageType.FILE, // 'RC:FileMsg'
  //         content: {
  //           name: this.name,
  //           size: this.size,
  //           type: this.type,
  //           fileUrl: this.fileUrl
  //         }
  //       };
  //     },
  //     setName(name) {this.name = name;},
  //     getName() {return this.name;},
  //     setSize(size) {this.size = size;},
  //     getSize() {return this.size;},
  //     setType(type) {this.type = type;},
  //     getType() {return this.type;},
  //     setFileUrl(fileUrl) {this.fileUrl = fileUrl;},
  //     getFileUrl() {return this.fileUrl;}
  //   };
  // })();
  //
  // (function() {
  //   MessageManager.ImgMessage = function() {
  //     this.content = "";
  //     this.imageUri = "";
  //     this.extra = {};
  //   };
  //
  //   MessageManager.ImgMessage.prototype = {
  //     constructor: MessageManager.ImgMessage,
  //     generate: function() {
  //       return {
  //         messageType: RongIMLib.MessageType.IMAGE, // 'RC:ImgMsg'
  //         content: {
  //           content: this.content, // // 压缩后的 base64 略缩图, 用来快速展示图片
  //           imageUri: this.imageUri, // 上传到服务器的 url. 用来展示高清图片
  //           extra: this.extra
  //         }
  //       };
  //     },
  //     setContent(content) {
  //       this.content = content;
  //     },
  //     getContent() {
  //       return this.content;
  //     },
  //     setImageUri(imageUri) {
  //       this.imageUri = imageUri;
  //     },
  //     getImageUri() {
  //       return this.imageUri;
  //     },
  //     setExtra(extra) {
  //       Object.assign(this.extra, extra);
  //     },
  //     getExtra() {
  //       return this.extra;
  //     }
  //   };
  // })();
  //
  // (function() {
  //   MessageManager.TextMessage = function() {
  //     this.content = "";
  //     this.extra = {};
  //   };
  //
  //   MessageManager.TextMessage.prototype = {
  //     constructor: MessageManager.TextMessage,
  //     generate: function() {
  //       return {
  //         messageType: RongIMLib.MessageType.TEXT, // 'RC:TxtMsg'
  //         content: {
  //           content: emoji.symbolToEmoji(this.content), // 文本内容
  //           extra: this.extra
  //         }
  //       };
  //     },
  //     setContent(content) {
  //       this.content = content;
  //     },
  //     getContent() {
  //       return this.content;
  //     },
  //     setExtra(extra) {
  //       Object.assign(this.extra, extra);
  //     },
  //     getExtra() {
  //       return this.extra;
  //     }
  //   };
  // })();

  for (let stakey in MessageManager) {
    for (let commonMethod in MessageManager.prototype) {
      if (MessageManager.prototype.hasOwnProperty(commonMethod)) {
        if (MessageManager[stakey].prototype[commonMethod]) continue;
        MessageManager[stakey].prototype[commonMethod] =
          MessageManager.prototype[commonMethod];
      }
    }
    if (MessageManager[stakey].prototype.proxyHandler) {
      MessageManager[stakey].prototype = new Proxy(
        MessageManager[stakey].prototype,
        MessageManager[stakey].prototype.proxyHandler
      );
    }
  }

  MessageManager._instance = new MessageManager();

  MessageManager.factory = function(type) {
    return new MessageManager[type]();
  };

  const normalizeByMessageType = {
    [MessageTypes.HB](message) {
      const extra = message.content.extra;
      const lang = getLanguage();
      const originRemarkText = extra.remark;
      const originDscText = extra.redpacketDesc;
      const toI18nText = extra.remarkI18n && extra.remarkI18n[lang];
      const zhRemarkText =
        extra.remarkI18n && extra.remarkI18n[getChineseKey()];
      extra.hourly = (zhRemarkText || originRemarkText) === "整点红包";
      extra.remark = toI18nText ? toI18nText : originRemarkText;
      extra.redpacketDesc =
        originRemarkText === originDscText ? toI18nText : originRemarkText;
    },
    [MessageTypes.FOLLOW_LOTTERY](message) {
      const extra = message.content.extra;
      const extraData = extra.data;
      let dataArr = [];
      if (!extraData) {
        return void 0;
      } else if (isString(extraData.data)) {
        try {
          dataArr = JSON.parse(extraData.data) || [];
        } catch (e) {
          console.log("normalizeByMessageType error", e);
        }
      } else {
        return void 0;
      }
      const lang = getLanguage();
      const langData = (
        dataArr.find(item => {
          return item.lang === lang;
        }) || { data: null }
      ).data;
      if (!!langData && isString(langData)) {
        extra.data = {
          ...extra.data,
          ...JSON.parse(langData)
        };
      }
    },
    [MessageTypes.FOLLOW_ORDER](message) {
      const extra = message.content.extra;
      const extraData = extra.data;
      let dataArr = [];
      if (!extraData) {
        return void 0;
      } else if (isArray(extraData)) {
        dataArr = extraData;
      } else if (isObject(extraData)) {
        try {
          dataArr = JSON.parse(extraData.data) || [];
        } catch (e) {
          console.log("normalizeByMessageType error", e);
        }
      } else {
        return void 0;
      }
      const lang = getLanguage();
      const langData = (
        dataArr.find(item => {
          return item.lang === lang;
        }) || { data: null }
      ).data;
      if (!!langData && isString(langData)) {
        extra.data = {
          ...JSON.parse(langData)
        };
      }
    },
    [PushTypes.FIREWORKS_EXPLODE](message) {
      const extra = message.content.extra;
      const extraData = extra.data;
      let dataArr = [];
      if (!extraData) {
        return void 0;
      } else if (isString(extraData.data)) {
        try {
          dataArr = JSON.parse(extraData.data) || [];
        } catch (e) {
          console.log("normalizeByMessageType error", e);
        }
      } else {
        return void 0;
      }
      const lang = getLanguage();
      const langData = (
        dataArr.find(item => {
          return item.lang === lang;
        }) || { data: null }
      ).data;
      if (!!langData && isString(langData)) {
        extra.data = {
          ...extra.data,
          ...JSON.parse(langData)
        };
      }
    },
    [MessageTypes.SHARE_BET_MSG](message) {
      const extra = message.content.extra;
      const extraData = extra.data;
      let dataArr = [];
      if (!extraData) {
        return void 0;
      } else if (isArray(extraData)) {
        dataArr = extraData;
      } else if (isObject(extraData)) {
        try {
          dataArr = JSON.parse(extraData.data) || [];
        } catch (e) {
          console.log("normalizeByMessageType error", e);
        }
      } else if (isString(extraData.data)) {
        try {
          dataArr = JSON.parse(extraData.data) || [];
        } catch (e) {
          console.log("normalizeByMessageType error", e);
        }
      } else {
        return void 0;
      }
      const lang = getLanguage();
      const langData = (
        dataArr.find(item => {
          return item.lang === lang;
        }) || { data: null }
      ).data;
      if (!!langData && isString(langData)) {
        extra.data = {
          ...JSON.parse(langData)
        };
      }
    },
    [PushTypes.LOTTERY_ORDER](message) {
      const extra = message.content.extra;
      const alertI18n = extra.aps.alertI18n;
      const lang = getLanguage();
      const text = alertI18n && alertI18n[lang];
      extra.message = text ? text : extra.message;
    },
    [PushTypes.MEMBER_MSG](message) {
      this[PushTypes.LOTTERY_ORDER](message);
    },
    [PushTypes.GIFT_BAG_ALERT](message) {
      this[PushTypes.LOTTERY_ORDER](message);
    }
  };

  return {
    // CreateModes,
    normalize(message) {
      try {
        if (!message) return;
        let messageContent = message.content || {};
        if (messageContent.message) {
          message = Object.assign(message, messageContent.message);
          messageContent = message.content;
        }
        let extra = messageContent.extra || {};
        if (isString(extra)) {
          messageContent.extra = extra = JSON.parse(extra);
        }
        if (messageContent.extra && messageContent.extra.user) {
          messageContent.user = {
            ...messageContent.user,
            ...messageContent.extra.user
          };
        }
        normalizeByMessageType[message.messageType] &&
          normalizeByMessageType[message.messageType](message);
        normalizeByMessageType[extra.type] &&
          normalizeByMessageType[extra.type](message);
      } catch (e) {
        console.log(e, message);
      }
      return message;
    },
    getInstance() {
      return MessageManager._instance;
    },
    factory(type) {
      return MessageManager.factory(type);
    },
    RedPacketMessage: function(msgBody = {}) {
      return new RongIMLib.BaseMessage(MessageTypes.HB, msgBody);
    },
    WelcomeMessage: function(msgBody = {}) {
      return new RongIMLib.BaseMessage(MessageTypes.WELCOME, msgBody);
    },
    EmojiMessage: function(msgBody = {}) {
      return new RongIMLib.BaseMessage(MessageTypes.Emoji, msgBody);
    },

    ImgMessage: RongIMLib.ImageMessage,
    TextMessage: function(msgBody = {}) {
      Object.assign(msgBody, {
        content: emoji.symbolToEmoji(msgBody.content || "")
      });
      return new RongIMLib.TextMessage(msgBody);
    },
    sendImageMessage: function(
      conversation = {},
      msgBody = {},
      hooks = {},
      options = {}
    ) {
      conversation = Object.assign(
        {
          conversationType: RongIMLib.ConversationType.CHATROOM
        },
        conversation
      );
      return RongIMLib.sendImageMessage(
        conversation,
        msgBody,
        hooks,
        options
      ).then(res => {
        if (res.code === 0) {
          Logger.prefixed.debug("融云", `发送图片消息成功`);
          return res.data;
        }
        throw new Error(`code: ${res.code}`);
      });
    }
  };
})();

export function getNormalizeMessage() {}

export function redPacketMsgHandler(message) {
  let messageType = message.messageType;

  if (messageType === MessageTypes.HB) {
    message.state = 1;
  }
  return message;
}

export function chatFormateDate(value) {
  if (!value) return "";
  let date = new Date(value);
  let currentDate = new Date();
  if (
    Math.abs(currentDate.getTime() - date.getTime()) < 1000 * 3600 * 24 &&
    Math.abs(currentDate.getDate() - date.getDate()) <= 0
  ) {
    date = DateUtil.getFormatDate2(date, "hh:mm:ss"); /* yymmddhhmmss */
    return date;
  } else if (Math.abs(currentDate.getFullYear() - date.getFullYear()) <= 0) {
    return DateUtil.getFormatDate2(date, "MM-dd hh:mm:ss");
  } else {
    return DateUtil.getFormatDate2(date, "yyyy-MM-dd hh:mm:ss");
  }
}

export function initPrivateListHeight() {
  let privateList = document.querySelector("#privateList");
  let chatControl = document.querySelector("#chatControl");
  let winH = window.innerHeight;
  if (privateList) {
    privateList.style.height =
      winH -
      privateList.getBoundingClientRect().top -
      chatControl.clientHeight +
      "px";
  }
}
